(function () {
    'use strict';
    /*
     * Copyright (c) 2014-15 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .directive('ihhNavbar', ihhNavbar);

    ihhNavbar.$inject = ['$window'];

    function ihhNavbar($window) {
        return {
            restrict: 'AE',
            transclude: true,
            scope: {
                collapseId: '@',
                hasCollapsible: '&',
                hasHelp: '&',
                brand: '@',
                brandImage: '@',
                brandUrl: '@',
                brandGlyphicon: '@',
                navbarStyles: '@',
                onBrandClick: '&',
                noButton: '=',
                extraAttributes: '='
            },
            templateUrl: 'navbar/navbar.tpl.html',
            link: function(scope, elem, attrs) {
                scope.hasBrandClick = function() {
                    return angular.isDefined(attrs.onBrandClick);
                };
                if (!scope.hasBrandClick()) {
                    scope.onBrandClick = function() {
                        $window.history.back();
                    };
                }
                if (angular.isUndefined(attrs.hasCollapsible)) {
                    scope.hasCollapsible = function() {
                        return true;
                    };
                }
                if (angular.isUndefined(attrs.hasHelp)) {
                    scope.hasHelp = function() {
                        return true;
                    };
                }
                if (angular.isUndefined(scope.brandGlyphicon)) {
                    scope.brandGlyphicon = 'glyphicon-share-alt reflect-horizontal';
                }
            }
        };
    }
})();